














// vue
import {Vue, Component, Watch} from 'vue-property-decorator';

// 组件
import NewsStyleOne from './NewsStyleOne.vue';
import LayoutOne from '@/components/layouts/LayoutOne.vue';
import {Toast} from 'vant';

// http
import http from '@/utils/http';
import {newsListAPI} from '@/api/index';

@Component({
  components: {
    styleOne: NewsStyleOne,
    layoutOne: LayoutOne,
  },
})
export default class App extends Vue {
  public layoutStyle: string = 'layoutOne';
  public mainStyle: string = 'styleOne';

  public data: any = {};

  public dataList: any = {};

  @Watch('$route')
  public watchData(value: any) {
    this.data = JSON.parse(value.query.data as string);
    this.getNewsList(this.data);
  }

  public mounted() {
    this.data = JSON.parse(this.$route.query.data as string);
    this.getNewsList(this.data);
  }

  // 获取新闻列表
  public getNewsList(item: any) {
    return new Promise((resolve, reject) => {
      const {id} = item;
      const body = {
        pid: id,
        isShow: '1',
      };
      const {requestInit} = newsListAPI;

      requestInit.body = JSON.stringify(body);

      http(newsListAPI).then((data: any) => {
        this.dataList = data;
      }).catch((reason) => {
        Toast('列表获取失败');
      });
    });
  }
}
